import { createContext, useContext, useState } from "react";
import useFetch from "../hooks/useFetch";
import { pageListFront } from "../services/pageService";

// Create context
const BannerContext = createContext();

// Create provider
export const BannerProvider = ({ children }) => {
  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["font-banners"],
    fetchFunction: async () => {
      const res = await pageListFront({
        // type: "Section",
        limit: 100,
      });
      return res?.docs;
    },
  });

  return (
    <BannerContext.Provider
      value={{
        data,
        isLoading,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => {
  return useContext(BannerContext);
};
